import $ from 'jquery';

if( $( '.menu-section' ).length ) {
  const menuFilterItem = document.querySelectorAll('.menu-filter-item')
  const menuProduct = document.querySelectorAll('.menu-product')

  function menuUpdate() {
    var hash = window.location.hash;  
    var hashCategory = hash.replace( '#', '' );

    //Check if the window has a hash on load and hide the cards that don't have the hash category
    if( hashCategory.length ){
      $( menuProduct ).each( function() {
        var product = $( this );
        if ( product.data('menu') == hashCategory ) {
          product.removeClass( 'hide-menu-section' );
        } else {
          product.addClass( 'hide-menu-section' );
        }
      });

      $( menuFilterItem ).each( function() {
        var menuItem = $( this );
        if ( menuItem.data('menu') == hashCategory ) {
          menuItem.addClass( 'active-menu' );
        } else {
          menuItem.removeClass( 'active-menu' );
        }
      });
    }
  }

  $( window ).on( 'load', function() {
    menuUpdate()
  } )

  $( window ).on( 'hashchange', function() {
    menuUpdate()
  } )
}